import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Modal } from '@st-operations/uikit/src/v2/index.js'

import DeliveryContent from './delivery-content'

import './styles.scss'
import { TabItem } from '_components/tab-item'

const MODAL_STYLES = {
  content: 'delivery-modal__container',
  childWrapper: 'delivery-modal__wrapper',
  innerWrapper: 'delivery-modal__inner-wrapper',
  headerClose: 'delivery-modal__close-button',
}

const DeliveryModal = ({ isOpen, onClose, onSave }) => {
  const TABS = {
    DELIVERY: 'Delivery',
  }

  const [tab, setTab] = useState(TABS.DELIVERY)

  return (
    <Modal isOpen={isOpen} onClose={onClose} classes={MODAL_STYLES}>
      <div className="delivery-modal__wrapper">
        <div className="delivery-modal__tabs">
          <For each="tabName" of={Object.keys(TABS)}>
            <TabItem
              key={tabName}
              onClick={() => setTab(TABS[tabName])}
              isSelected={tab === TABS[tabName]}
              item={TABS[tabName]}
            />
          </For>
        </div>
        <div className="delivery-modal__content">
          {tab === TABS.DELIVERY && <DeliveryContent onSave={onSave} onClose={onClose} />}
        </div>
      </div>
    </Modal>
  )
}

DeliveryModal.propTypes = {
  id: PropTypes.string,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
}

DeliveryModal.defaultProps = {
  id: '',
  isOpen: false,
  onClose: () => {},
}

export default React.memo(DeliveryModal)
